import { render, staticRenderFns } from "./AwardWinner.vue?vue&type=template&id=74293a0f&"
import script from "./AwardWinner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AwardWinner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74293a0f')) {
      api.createRecord('74293a0f', component.options)
    } else {
      api.reload('74293a0f', component.options)
    }
    module.hot.accept("./AwardWinner.vue?vue&type=template&id=74293a0f&", function () {
      api.rerender('74293a0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AwardWinner/AwardWinner.vue"
export default component.exports